import { useContext, useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import {
  Datepicker,
  Form,
  Number,
  Select,
  Text,
} from '../../../Components/Form';
import FileUploader from '../../../Components/Form/FileUpload';
import Textarea from '../../../Components/Form/Textarea';
import Loading from '../../../Components/Loading/Loading';
import ShowImageModal from '../../../Components/Modal/ShowImageModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useRole } from '../../../Hooks/Role';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import {
  dateToJalali,
  getHasHasNot,
  getPhotoId,
  getStatus,
  serverErrorHandler,
} from '../../../Utils/Helpers';
import { GymContext } from '../Context/GymContext';
import { confirmationGym } from '../Utils/Helpers';

const validationSchema = Yup.object({
  name: Yup.string()
    .typeError('نام زورخانه الزامی است')
    .required('نام زورخانه الزامی است')
    .max(190, 'نام زورخانه نمی تواند بیشتر از 190 کاراکتر باشد'),
  province_id: Yup.number()
    .typeError('انتخاب استان الزامی است')
    .required('انتخاب استان الزامی است'),
  city_id: Yup.number()
    .typeError('انتخاب شهر الزامی است')
    .required('انتخاب شهر الزامی است'),
  manager_photo: Yup.array()
    .typeError('انتخاب عکس پرسنلی الزامی است')
    .required('انتخاب عکس پرسنلی الزامی است'),
  gym_thumbnail: Yup.array()
    .typeError('انتخاب تصاویر زورخانه الزامی است')
    .required('انتخاب تصاویر زورخانه الزامی است'),
  zip_code: Yup.string()
    .required('کد پستی الزامی است')
    .min(10, 'کد پستی باید 10 رقم باشد')
    .max(10, 'کد پستی باید 10 رقم باشد'),
  capacity: Yup.number()
    .typeError('ظرفیت تماشاچی الزامی است')
    .required('ظرفیت تماشاچی الزامی است'),
  athlete_capacity: Yup.number()
    .typeError('ظرفیت گود الزامی است')
    .required('ظرفیت گود الزامی است'),
  area: Yup.string().required(' مساحت الزامی است'),
  phone: Yup.string().required('تلفن الزامی است'),
  foundation_date: Yup.string().required('تاریخ تاسیس الزامی است'),
  address: Yup.string().required('آدرس زورخانه الزامی است'),
  type: Yup.number()
    .typeError('نوع زورخانه الزامی است')
    .required('نوع زورخانه الزامی است'),
  owner_type: Yup.number()
    .typeError('نوع مالکیت زورخانه الزامی است')
    .required('نوع مالکیت زورخانه الزامی است'),
  organization: Yup.number().typeError('').nullable(),
  first_name: Yup.string().required('نام مدیر زورخانه الزامی است'),
  last_name: Yup.string().required('نام خانوادگی مدیر زورخانه الزامی است'),
  father_name: Yup.string().required('نام پدر مدیر زورخانه الزامی است'),
  birth_date: Yup.string().required('تاریخ تولد مدیر زورخانه الزامی است'),
  manager_mobile: Yup.string()
    .required('موبایل مدیر زورخانه الزامی است')
    .min(11, 'موباید باید 11 رقم باشد و با 0 شروع شود.')
    .max(11, 'موباید باید 11 رقم باشد و با 0 شروع شود.'),
  manager_address: Yup.string().required('آدرس مدیر زورخانه الزامی است'),
  wrestling_hall: Yup.number()
    .typeError('انتخاب دارای سالن کشتی الزامی است')
    .required('انتخاب دارای سالن کشتی الزامی است'),
  status: Yup.number()
    .typeError('انتخاب وضعیت الزامی است')
    .required('انتخاب وضعیت الزامی است'),
  board_confirm: Yup.number().typeError().nullable(),
  federation_confirm: Yup.number().typeError().nullable(),
});

const Edit = () => {
  const { id } = useParams();
  const { can, canBoard } = useRole();
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { get, put } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();
  const context = useContext(GymContext);
  const [loading, setLoading] = useState(true);
  const [cityLoading, setCityLoading] = useState(false);
  const [showOrganization, setShowOrganization] = useState(false);
  const [modalImageShow, setModalImageShow] = useState(false);
  const [imageSrcModal, setImageSrcModal] = useState('');

  useEffect(() => {
    const getData = async () => {
      await getGym();
      await getGymTypes();
      await getTypes();
      await getOrganizations();
      await getProvinces();
    };

    getData();
  }, [id]);

  const getGymTypes = async () => {
    setLoading(true);
    await get(
      '/gym/gym-types',
      (res) => {
        context.gymTypes = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getTypes = async () => {
    setLoading(true);
    await get(
      '/gym/types',
      (res) => {
        context.types = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };
  const getOrganizations = async () => {
    setLoading(true);
    await get(
      '/gym/organization',
      (res) => {
        context.organizations = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };
  const getProvinces = async () => {
    setLoading(true);
    await get(
      '/province',
      (res) => {
        context.provinces = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getGym = async () => {
    setLoading(true);
    await get(
      `/gym/${id}`,
      (res) => {
        const data = res.data;
        context.gym = data;
        if (data?.owner_type == 4) {
          setShowOrganization(true);
        }
        getCities(data?.province?.id);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    if (values['gym_thumbnail'].length > 0) {
      if (values['gym_thumbnail'].length < 2) {
        return setServerErrors({
          serverErrors,
          gym_photos: 'آپلود دو تصویر زورخانه الزامی است.',
        });
      }
      values['gym_thumbnail_ids'] = getPhotoId(values['gym_thumbnail']);
    }
    if (values['manager_photo'].length > 0) {
      values['manager_photo_id'] = getPhotoId(values['manager_photo'], false);
    }

    if (values?.owner_type != 4) {
      values['organization'] = null;
    }

    setFormSubmitLoaing(true);
    await put(
      `/gym/${id}`,
      values,
      (res) => {
        success(`زورخانه "${values?.name}" باموفقیت ویرایش شد.`);
        setFormSubmitLoaing(false);
        navigate(`/gym/edit/${id}`);
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`زورخانه "${values?.name}" به علت خطا ویرایش نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  const getCities = async (provinceId) => {
    setCityLoading(true);
    await get(
      `/city/${provinceId}`,
      (res) => {
        context.cities = res.data;
        setCityLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات شهر ها با خطا روبرو شد.');
        setCityLoading(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title='ایجاد زورخانه'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/gym'
      />
      <Form
        initialValues={{
          name: context?.gym?.name,
          province_id: context?.gym?.province?.id,
          city_id: context?.gym?.city?.id,
          manager_photo: [],
          gym_thumbnail: [],
          zip_code: context?.gym?.zip_code,
          capacity: context?.gym?.capacity,
          athlete_capacity: context?.gym?.athlete_capacity,
          area: context?.gym?.area,
          phone: context?.gym?.phone,
          foundation_date: dateToJalali(context?.gym?.foundation_date),
          address: context?.gym?.address,
          type: context?.gym?.type,
          owner_type: context?.gym?.owner_type,
          organization: context?.gym?.organization ?? '',
          first_name: context?.gym?.first_name,
          last_name: context?.gym?.last_name,
          father_name: context?.gym?.father_name,
          birth_date: dateToJalali(context?.gym?.birth_date),
          manager_mobile: context?.gym?.manager_mobile,
          manager_address: context?.gym?.manager_address,
          federation_confirm: context?.gym?.federation_confirm,
          board_confirm: context?.gym?.board_confirm,
          wrestling_hall: context?.gym?.wrestling_hall,
          status: context?.gym?.status,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  disabled={
                    can('Super Admin') || can('User') || can('Gym Manager')
                      ? false
                      : true
                  }
                  title='نام زورخانه'
                  name='name'
                  serverError={serverErrors.name}
                />
              </div>
              <div className='col-12'>
                <Text
                  disabled={
                    can('Super Admin') || can('User') || can('Gym Manager')
                      ? false
                      : true
                  }
                  title='کد پستی'
                  name='zip_code'
                  serverError={serverErrors.zip_code}
                />
              </div>
              <div className='col-12'>
                <Number
                  title='ظرفیت تماشاچی'
                  name='capacity'
                  serverError={serverErrors.capacity}
                />
              </div>
              <div className='col-12'>
                <Number
                  title='ظرفیت گود'
                  name='athlete_capacity'
                  serverError={serverErrors.athlete_capacity}
                />
              </div>
              <div className='col-12'>
                <Text
                  title='مساحت'
                  name='area'
                  serverError={serverErrors.area}
                />
              </div>
              <div className='col-12'>
                <Text
                  disabled={
                    can('Super Admin') || can('User') || can('Gym Manager')
                      ? false
                      : true
                  }
                  title='تلفن زورخانه'
                  name='phone'
                  serverError={serverErrors.phone}
                />
              </div>
              <div className='col-12'>
                <Datepicker
                  disabled={can('Super Admin') || can('User') ? false : true}
                  title='تاریخ تاسیس'
                  name='foundation_date'
                  minDate={new Date('1730/01/01')}
                  serverError={serverErrors.foundation_date}
                />
              </div>
              <div className='col-12'>
                {context.gym?.gym_thumbnail?.map((item) => (
                  <img
                    onClick={() => {
                      setImageSrcModal(item?.path);
                      setModalImageShow(true);
                    }}
                    key={item?.id}
                    src={item?.path}
                    alt=''
                    className='m-3 img-thumbnail c-pointer'
                    style={{ width: '100px', height: '100px' }}
                  />
                ))}
                {can('Super Admin') || can('User') || can('Gym Manager') ? (
                  <FileUploader
                    method='post'
                    name='gym_thumbnail'
                    title='تصاویر زورخانه (2 تصویر)'
                    maxFileSize='512KB'
                    roles={['image/jpg', 'image/jpeg', 'image/png']}
                    serverUrl='/file?location=gyms&public=0'
                    maxFiles={2}
                    serverError={serverErrors.gym_thumbnail}
                  />
                ) : null}
              </div>
              <div className='col-12'>
                <Textarea
                  disabled={
                    can('Super Admin') || can('User') || can('Gym Manager')
                      ? false
                      : true
                  }
                  name='address'
                  serverError={serverErrors.address}
                  title='آدرس زورخانه'
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Select
                disabled={
                  can('Super Admin') || can('User') || can('Gym Manager')
                    ? false
                    : true
                }
                title='استان'
                name='province_id'
                optionLabel='name'
                optionValue='id'
                options={context.provinces}
                onChange={(value) => getCities(value)}
                serverError={serverErrors.province_id}
              />
            </div>
            {!cityLoading && context.cities.length > 0 ? (
              <div className='col-12'>
                <Select
                  disabled={
                    can('Super Admin') || can('User') || can('Gym Manager')
                      ? false
                      : true
                  }
                  title='شهر'
                  name='city_id'
                  optionLabel='name'
                  optionValue='id'
                  options={context.cities}
                  serverError={serverErrors.city_id}
                />
              </div>
            ) : (
              <div className='col-12'>
                <Select
                  disabled={
                    can('Super Admin') || can('User') || can('Gym Manager')
                      ? false
                      : true
                  }
                  title='شهر'
                  name='city_id'
                  optionLabel='name'
                  optionValue='id'
                  options={[]}
                  serverError={serverErrors.city_id}
                />
              </div>
            )}
            <div className='col-12'>
              <Select
                title='نوع زورخانه'
                name='type'
                optionLabel='title'
                optionValue='id'
                options={context.types}
                serverError={serverErrors.type}
              />
            </div>
            <div className='col-12'>
              <Select
                title='نوع مالکیت'
                name='owner_type'
                optionLabel='title'
                optionValue='id'
                onChange={(value) =>
                  setShowOrganization(value == 4 ? true : false)
                }
                options={context.gymTypes}
                serverError={serverErrors.owner_type}
              />
            </div>
            {showOrganization && (
              <div className='col-12'>
                <Select
                  title='سازمان'
                  name='organization'
                  optionLabel='title'
                  optionValue='id'
                  options={context.organizations}
                  serverError={serverErrors.organization}
                />
              </div>
            )}
            <div className='col-12'>
              <Select
                title='دارای سالن کشتی'
                name='wrestling_hall'
                optionLabel='label'
                optionValue='value'
                options={getHasHasNot()}
                serverError={serverErrors.wrestling_hall}
              />
            </div>
            <div className='col-12'>
              <div className=' my-3 border-bottom'>
                <h1 className='text-dark f-14 font-weight-bold'>
                  مشخصات مدیر زورخانه
                </h1>
              </div>
            </div>
            <div className='col-12'>
              <Text
                disabled={
                  can('Super Admin') || can('User') || can('Gym Manager')
                    ? false
                    : true
                }
                title='نام'
                name='first_name'
                serverError={serverErrors.first_name}
              />
            </div>
            <div className='col-12'>
              <Text
                disabled={
                  can('Super Admin') || can('User') || can('Gym Manager')
                    ? false
                    : true
                }
                title='نام خانوادگی'
                name='last_name'
                serverError={serverErrors.last_name}
              />
            </div>
            <div className='col-12'>
              <Text
                disabled={
                  can('Super Admin') || can('User') || can('Gym Manager')
                    ? false
                    : true
                }
                title='نام پدر'
                name='father_name'
                serverError={serverErrors.father_name}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                disabled={
                  can('Super Admin') || can('User') || can('Gym Manager')
                    ? false
                    : true
                }
                title='تاریخ تولد'
                name='birth_date'
                minDate={new Date('1730/01/01')}
                serverError={serverErrors.birth_date}
              />
            </div>
            <div className='col-12'>
              <Text
                disabled={
                  can('Super Admin') || can('User') || can('Gym Manager')
                    ? false
                    : true
                }
                title='موبایل'
                name='manager_mobile'
                serverError={serverErrors.manager_mobile}
              />
            </div>
            <div className='col-12'>
              <Textarea
                disabled={
                  can('Super Admin') || can('User') || can('Gym Manager')
                    ? false
                    : true
                }
                title='آدرس'
                name='manager_address'
                serverError={serverErrors.manager_address}
              />
            </div>
            <div className='col-12'>
              <img
                onClick={() => {
                  setImageSrcModal(context?.gym?.manager_photo?.path);
                  setModalImageShow(true);
                }}
                src={context?.gym?.manager_photo?.path}
                alt=''
                className='m-3 img-thumbnail c-pointer'
                style={{ width: '100px', height: '100px' }}
              />
              {can('Super Admin') || can('User') || can('Gym Manager') ? (
                <FileUploader
                  method='post'
                  name='manager_photo'
                  title='عکس پرسنلی'
                  maxFileSize='512KB'
                  allowMultiple={false}
                  roles={['image/jpg', 'image/jpeg', 'image/png']}
                  serverUrl='/file?location=gyms&public=0'
                  maxFiles={1}
                  serverError={serverErrors.manager_photo}
                />
              ) : null}
            </div>
            <div className='col-12'>
              <div className=' my-3 border-bottom'></div>
            </div>
            {can('Federation') || can('Super Admin') || can('Gym Manager') ? (
              <div className='col-12'>
                <Select
                  title='تایید فدراسیون'
                  name='federation_confirm'
                  optionLabel='label'
                  optionValue='value'
                  options={confirmationGym()}
                  serverError={serverErrors.federation_confirm}
                />
              </div>
            ) : null}
            {canBoard() || can('Super Admin') || can('Gym Manager') ? (
              <div className='col-12'>
                <Select
                  title='تایید هیئت'
                  name='board_confirm'
                  optionLabel='label'
                  optionValue='value'
                  options={confirmationGym()}
                  serverError={serverErrors.board_confirm}
                />
              </div>
            ) : null}

            <div className='col-12'>
              <Select
                disabled={
                  can('Super Admin') || can('Gym Manager') ? false : true
                }
                title='وضعیت'
                name='status'
                optionLabel='label'
                optionValue='value'
                options={getStatus()}
                serverError={serverErrors.status}
              />
            </div>
          </div>
        </div>
      </Form>
      <ShowImageModal
        setModalIsOpen={setModalImageShow}
        modalIsOpen={modalImageShow}
        image={imageSrcModal}
      />
    </Master>
  );
};

export default Edit;
